import { render, staticRenderFns } from "./CustomerOrderItemRO.vue?vue&type=template&id=0b1cd492&scoped=true&lang=pug"
import script from "./CustomerOrderItemRO.vue?vue&type=script&lang=js"
export * from "./CustomerOrderItemRO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1cd492",
  null
  
)

export default component.exports